import { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table, Input, CardBody } from 'reactstrap';
import { Search } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTryouts, handleBackPagination, handleNextPagination, handleClickPagination } from 'Component/Learning/Tryout/TryoutUtils';
import { setFilters } from 'Features/Learning/Tryout/tryoutSlice';
import PaginationComponent from 'Component/Learning/Common/Pagination';

const ModalTryout = ({ isOpen, toggle, onSelect }) => {
  const dispatch = useDispatch();
  const filters = useSelector(state => state.Tryout.filters);
  const tryoutData = useSelector(state => state.Tryout.data.data);
  const pagination = useSelector(state => state.Tryout.data.pagination);
  const isLoading = useSelector(state => state.Tryout.isLoading);
  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchTryouts(dispatch, filters);
    }
  }, [dispatch, filters, isOpen, refetch]);

  const handleSelectTryout = (tryout) => {
    onSelect(tryout);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Pilih Tryout</ModalHeader>
      <ModalBody>
        <div className="faq-form mb-3">
          <Input
            className="form-control"
            type="text"
            placeholder="Search tryout..."
            value={filters["filter[title]"] || ''}
            onChange={(e) => {
              dispatch(setFilters({
                ...filters,
                "filter[title]": e.target.value,
              }));
            }}
            onKeyUp={(e) => e.key === 'Enter' && setRefetch(!refetch)}
          />
          <Search className="search-icon" />
        </div>
        <Table className="table-bordered table-hover">
          <thead className="table-light">
            <tr>
              <th>ID</th>
              <th>Nama Tryout</th>
              <th className="text-center">Pilih</th>
            </tr>
          </thead>
          <tbody>
            {tryoutData && tryoutData.map((tryout) => (
              <tr key={tryout.id}>
                <td>{tryout.id}</td>
                <td>{tryout.title}</td>
                <td className="text-center">
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleSelectTryout(tryout)}
                  >
                    Pilih
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {pagination && (
          <CardBody>
            <PaginationComponent
              pagination={pagination}
              handleBackPagination={() => {
                handleBackPagination(pagination, filters, dispatch, setFilters, setRefetch);
              }}
              handleClickPagination={(page) => {
                handleClickPagination(page, filters, dispatch, setFilters, setRefetch);
              }}
              handleNextPagination={() => {
                handleNextPagination(pagination, filters, dispatch, setFilters, setRefetch);
              }}
            />
          </CardBody>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Tutup
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalTryout;